import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { z } from "zod";

export type SenderNameJSON = z.infer<typeof SenderNameSchema.SenderNameJSONZ>;
export type SenderNameParams = z.infer<typeof SenderNameSchema.SenderNameZ>;

export default class SenderNameSchema {
  public static readonly SenderNameJSONZ = z.string().min(1, { message: "Sender name cannot be empty" });
  public static readonly SenderNameZ = z.string().min(1, { message: "Sender name cannot be empty" });

  public static readonly codec = z.codec(SenderNameSchema.SenderNameJSONZ, SenderNameSchema.SenderNameZ, {
    decode: (data) => data,
    encode: (senderName) => senderName,
  });

  public static validateJSON(values: unknown): SenderNameParams {
    return parseOrThrow(SenderNameSchema.SenderNameZ, values, {
      logError: true,
      schemaName: "SenderNameParams",
      operation: "validateJSON",
      payloadSample: values,
    });
  }

  public static isValidJSON(values: unknown): values is SenderNameParams {
    try {
      SenderNameSchema.validateJSON(values);
      return true;
    } catch {
      return false;
    }
  }

  public static deserialize(data: unknown): SenderNameParams {
    const parsed = parseOrThrow(SenderNameSchema.SenderNameJSONZ, data, {
      logError: true,
      schemaName: "SenderNameJSON",
      operation: "deserialize",
      payloadSample: data,
    });
    return SenderNameSchema.codec.decode(parsed);
  }

  public static serialize(data: SenderNameParams): SenderNameJSON {
    const parsed = SenderNameSchema.validateJSON(data);
    return SenderNameSchema.codec.encode(parsed);
  }
}
